import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { MdOpenInNew } from "react-icons/md";
import { FaClone } from "react-icons/fa";
import { IoMdCopy } from "react-icons/io";

import Footer from "../../components/Footer";
import Sidebar from "../../components/Sidebar";
import {
	Apresentation,
	ContentMain,
	DefaultButton,
	Error,
	MyTable,
	MyTableBody,
	MyTableHead,
	MyTableTR,
	Page,
	ScreenView,
	SubPageMain,
} from "../../style/default";
import { Skeleton } from "../../components/Skeleton/table";
import { authApi } from "../../services/api";
import { TOASTIFY_OPTIONS } from "../../style/global";
import { MyHorizontalScrollView } from "../Sectors/style";
import MyTooltip from "../../components/Tooltip";
import { debounce } from "../../utils/debounce";
import { BiMessageSquareEdit, BiTrash } from "react-icons/bi";
import { ModalContext } from "../../context/modal";
import { EditBot } from "./edit-bot";
import { NewBot } from "./new-bot";

function BotBuilder() {
	const { open, handleOpenModal } = useContext(ModalContext);
	const [modalData, setModalData] = useState({});
	const [modalSettings, setModalSettings] = useState({
		edit: false,
		new: false,
	});
	const [bots, setBots] = useState([]);
	const [spreadAccounts, setSpreadAccounts] = useState([]);
	const [subdomains, setSubdomains] = useState([]);
	const [filteredBots, setFilteredBots] = useState([...bots]);
	const [searchQuery, setSearchQuery] = useState("");
	const [isLoading, setIsLoading] = useState(false);

	const populateTable = async () => {
		try {
			setIsLoading(true);
			const { data } = await authApi.get("/bot-builder/list");
			setIsLoading(false);
			setSearchQuery("");
			setBots(data);
		} catch (error) {
			setIsLoading(false);
			toast.error("Não foi possivel encontrar os bots", TOASTIFY_OPTIONS);
		}
	};

	const handleAccounts = async () => {
		try {
			const { data } = await authApi.get("/bot-builder/accounts");
			setSubdomains(data);
		} catch (error) {}
	};

	const handleSpreadAccounts = async () => {
		try {
			const { data } = await authApi.get("/api/accounts");
			setSpreadAccounts(data);
		} catch (error) {}
	};

	useEffect(() => {
		populateTable();
		handleAccounts();
		handleSpreadAccounts();
	}, []);

	useEffect(() => {
		const filtered = bots.filter(
			(acc) =>
				acc?.bot?.toLowerCase()?.includes(searchQuery.toLowerCase()) ||
				acc?.number?.toLowerCase()?.includes(searchQuery.toLowerCase()) ||
				acc?.accountName?.toLowerCase()?.includes(searchQuery.toLowerCase()) ||
				acc?.botName?.toLowerCase()?.includes(searchQuery.toLowerCase())
		);
		setFilteredBots(filtered);
	}, [searchQuery, bots]);

	const handleSearch = (event) => {
		const query = event.target.value;
		setSearchQuery(query);
	};

	async function handleCloneBot(botId) {
		try {
			const response = window.confirm("Deseja realmente clonar este bot?");
			if (!response) return;

			let botName = window.prompt("Informe o nome do bot:");

			await authApi.post("/bot-builder/clone", {
				botId,
				botName,
			});
		} catch (error) {
			toast.error("Não foi possivel clonar o bot", TOASTIFY_OPTIONS);
		}
	}

	function handleModal(type, open, data) {
		return () => {
			setModalData(data);
			setModalSettings((e) => {
				const aux = {};
				Object.entries(e).forEach((k, v) => {
					aux[k] = false;
				});
				return {
					...aux,
					[type]: open,
				};
			});
			handleOpenModal();
		};
	}

	async function handleDeleteBot(item) {
		const confirmDelete = window.confirm("Deseja realmente deletar este bot?");

		if (!confirmDelete) return;

		try {
			await authApi.post(`/bot-builder/delete/${item.bot}`);
			toast.success("Bot excluido com sucesso", TOASTIFY_OPTIONS);
			populateTable();
		} catch (error) {}
	}

	return (
		<Page>
			{open && modalSettings.edit && (
				<EditBot
					open={open}
					populateTable={populateTable}
					data={modalData}
					spreadAccounts={spreadAccounts}
				/>
			)}
			{open && modalSettings.new && (
				<NewBot
					open={open}
					populateTable={populateTable}
					data={modalData}
					spreadAccounts={spreadAccounts}
				/>
			)}
			<Sidebar activeMenu="bot-builder" />
			<ScreenView>
				<ContentMain>
					<SubPageMain>
						<Apresentation>
							<span>Bots</span>
							<DefaultButton
								headerButton
								onClick={handleModal("new", true, subdomains)}
							>
								Novo bot
							</DefaultButton>
						</Apresentation>
						{isLoading ? (
							<Skeleton
								data={[
									"id do bot",
									"cliente",
									"whatsapp",
									"nome do bot",
									"acoes",
								]}
							/>
						) : (
							<>
								<MyHorizontalScrollView>
									<div>
										<input
											type="text"
											onChange={debounce(handleSearch, 1000)}
											placeholder="Filtrar por Conta, número ou id do bot"
											title="Filtrar por Conta, número ou id do bot"
										/>
									</div>
								</MyHorizontalScrollView>

								{bots && bots.length ? (
									<>
										<MyTable responsive>
											<MyTableHead>
												<MyTableTR>
													<th>id do bot</th>
													<th>Cliente</th>
													<th>Whatsapp</th>
													<th>Nome do bot</th>
													<th>Ações</th>
												</MyTableTR>
											</MyTableHead>
											<MyTableBody>
												{filteredBots?.map((item) => (
													<MyTableTR key={item._id}>
														<td>{item.bot ? item.bot : "-"}</td>
														<td>{item.accountName ? item.accountName : "-"}</td>
														<td>{item.number ? item.number : "-"}</td>
														<td>{item.botName ? item.botName : "-"}</td>
														<td
															style={{
																display: "flex",
																justifyContent: "center",
															}}
														>
															<MyTooltip label="Acessar bot">
																<DefaultButton
																	onClick={() => {
																		const authuser = localStorage.getItem(
																			"@SpreadChat:authUser"
																		);
																		window
																			.open(
																				`https://www.builder.eloz.io/builder/${item.bot}?authuser=${authuser}`,
																				"_blank"
																			)
																			.focus();
																	}}
																>
																	<MdOpenInNew size={20} />
																</DefaultButton>
															</MyTooltip>
															<MyTooltip label="Clonar Bot">
																<DefaultButton
																	onClick={() => handleCloneBot(item.bot)}
																>
																	<FaClone size={20} />
																</DefaultButton>
															</MyTooltip>
															<MyTooltip label="Editar Bot">
																<DefaultButton
																	onClick={handleModal("edit", true, item)}
																>
																	<BiMessageSquareEdit size={20} />
																</DefaultButton>
															</MyTooltip>
															<MyTooltip label="Excluir Bot">
																<DefaultButton
																	onClick={() => handleDeleteBot(item)}
																>
																	<BiTrash size={20} />
																</DefaultButton>
															</MyTooltip>
															<MyTooltip label="Copiar link">
																<DefaultButton
																	onClick={() => {
																		const authuser = localStorage.getItem(
																			"@SpreadChat:authUser"
																		);
																		const url = `https://www.builder.eloz.io/builder/${item.bot}?authuser=${authuser}`;

																		navigator.clipboard.writeText(url);
																	}}
																>
																	<IoMdCopy size={20} />
																</DefaultButton>
															</MyTooltip>
														</td>
													</MyTableTR>
												))}
											</MyTableBody>
										</MyTable>
									</>
								) : (
									<Error>Nenhum dado encontrado</Error>
								)}
							</>
						)}
					</SubPageMain>
				</ContentMain>
				<Footer />
			</ScreenView>
		</Page>
	);
}

export { BotBuilder };
